module.exports = __webpack_public_path__ + "static/solution2-a6e9b578a713ad9342d045445cecad50.png";